import React, {useRef, useState, useEffect} from 'react';
import './styles.css';
import {RootStateOrAny, useDispatch, useSelector} from 'react-redux';
import {
  clearRequestPayload,
  setStatusToggle,
  updateRequestPayload,
} from '@app/screens/zho/pages/fc-admin/redux/tabName';
import {
  clearRequestPayloadOrder,
  updateRequestPayloadOrder,
} from '../../pages/ho-admin/redux/orderStore';
import {
  fcDashboardActions,
  fetchRequestFormDataCreator,
} from '@app/screens/zho/pages/fc-admin/redux-api/slice';
import {
  fetchInvoiceFormDataCreator,
  fetchOrderFormDataCreator,
} from '../../pages/ho-admin/redux-api/slice';

type SegmentedControlProps = {
  name: string;
  segments: any[];
  callback: (value?: any, index?: number) => void;
  defaultIndex?: number;
  controlRef: any;
  containerStyle?: any;
  itemStyle?: any;
  roleId: number;
};

export const ZhoToggleSeperator: React.FC<SegmentedControlProps> = ({
  name,
  segments,
  callback,
  defaultIndex = 1,
  controlRef,
  roleId,
  containerStyle = {},
  itemStyle = {},
}) => {
  const [activeIndex, setActiveIndex] = useState(defaultIndex);
  const componentReady = useRef();
  const dispatch = useDispatch();

  const userLoginInfo = useSelector(
    (state: RootStateOrAny) => state.appState.userInfo,
  );

  const screenNo = useSelector(
    (state: RootStateOrAny) => state?.tabNames.value.screenNo,
  );

  const screenIndex = useSelector(
    (state: RootStateOrAny) => state?.tabNames.value.activeTabIndex,
  );

  const userTab = useSelector(
    (state: RootStateOrAny) =>
      state.hoOrderStore.value.requestPayloadOrder.type,
  );

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    componentReady.current = true;
    return () => {
      dispatch(setStatusToggle(1));
    };
  }, []);

  useEffect(() => {
    const activeSegmentRef = segments[activeIndex].ref;
    const {offsetWidth, offsetLeft} = activeSegmentRef.current;
    const {style} = controlRef.current;
    style.setProperty('--highlight-width', `${offsetWidth + 12}px`);
    style.setProperty('--highlight-x-pos', `${offsetLeft}px`);
  }, [activeIndex, callback, controlRef, segments]);

  const onInputChange = (value: any, index: number) => {
    setActiveIndex(index);
    callback(value, index);
  };

  const handleClick = (i: number) => {
    if (i !== activeIndex) {
      dispatch(setStatusToggle(i));

      if (screenNo === 1) {
        if (roleId === 1) {
          switch (i) {
            case 0:
              i = 1;
              break;
            case 1:
              i = 2;
              break;
            case 2:
              i = 3;
              break;
            case 3:
              i = 4;
              break;
            case 4:
              i = 5;
              break;
            default:
              i = 0;
              break;
          }
          dispatch(setStatusToggle(i));

          dispatch(
            updateRequestPayload({
              currentStaffPositionId: 0,
              pageSize: 10,
              pageNumber: 0,
              requestFormNo: '',
              mrStaffIds: [],
              state: '',
              hq: [],
              startDate: '',
              endDate: '',
            }),
          );
          dispatch(
            fetchRequestFormDataCreator(
              {
                currentStaffPositionId: userLoginInfo?.staffPositionId,
                pageSize: 10,
                pageNumber: 0,
                requestFormNo: '',
                mrStaffIds: [],
                state: '',
                hq: [],
                startDate: '',
                endDate: '',
              },
              i,
            ),
          );
          dispatch(clearRequestPayload());
        } else if (roleId === 4) {
          switch (i) {
            case 0:
              i = 1;
              break;
            case 1:
              i = 2;
              break;
            case 2:
              i = 3;
              break;
            case 3:
              i = 4;
              break;
            case 4:
              i = 5;
              break;
            case 5:
              i = 6;
              break;
            default:
              i = 0;
              break;
          }
          dispatch(setStatusToggle(i));

          dispatch(
            updateRequestPayloadOrder({
              ...updateRequestPayloadOrder,
              currentStaffPositionId: userLoginInfo?.staffPositionId,
              division: [],
              pageSize: 10,
              pageNumber: 0,
              formNo: '',
              mrStaffIds: [],
              state: '',
              hq: [],
              startDate: '',
              endDate: '',
              tabType: i,
              type: userTab,
            }),
          );
          dispatch(
            fetchOrderFormDataCreator(
              {
                ...updateRequestPayloadOrder,
                currentStaffPositionId: userLoginInfo?.staffPositionId,
                division: [],
                pageSize: 10,
                pageNumber: 0,
                formNo: '',
                mrStaffIds: [],
                state: '',
                hq: [],
                startDate: '',
                endDate: '',
                tabType: i,
                type: userTab,
              },
              i,
              'fc',
            ),
          );
          dispatch(clearRequestPayloadOrder());
        }
      } else if (screenNo === 2) {
        if (screenIndex === 0) {
          switch (i) {
            case 0:
              i = 1;
              break;
            case 1:
              i = 2;
              break;
            case 2:
              i = 3;
              break;
            default:
              if (i === segments.length - 1) {
                i = 0;
              } else {
                i = 1; // Default case
              }
              break;
          }
          dispatch(setStatusToggle(i));
          dispatch(
            updateRequestPayloadOrder({
              division: [],
              currentStaffPositionId: userLoginInfo?.staffPositionId,
              pageSize: 10,
              pageNumber: 0,
              formNo: '',
              mrStaffIds: [],
              state: '',
              hq: [],
              startDate: '',
              endDate: '',
              tabType: 1,
              type: 1,
            }),
          );
          dispatch(
            fetchOrderFormDataCreator(
              {
                currentStaffPositionId: userLoginInfo?.staffPositionId,
                division: [],
                pageSize: 10,
                pageNumber: 0,
                formNo: '',
                mrStaffIds: [],
                state: '',
                hq: [],
                startDate: '',
                endDate: '',
              },
              i,
              'ho',
            ),
          );
          dispatch(clearRequestPayloadOrder());
        } else {
          switch (i) {
            case 0:
              i = 2;
              break;
            case 1:
              i = 1;
              break;
            case 2:
              i = 3;
              break;
            default:
              if (i === segments.length - 1) {
                i = 0;
              } else {
                i = 2; // Default case
              }
              break;
          }

          dispatch(setStatusToggle(i));
          dispatch(
            updateRequestPayloadOrder({
              division: [],
              currentStaffPositionId: userLoginInfo?.staffPositionId,
              pageSize: 10,
              pageNumber: 0,
              formNo: '',
              mrStaffIds: [],
              state: '',
              hq: [],
              startDate: '',
              endDate: '',
              tabType: 1,
              type: 1,
            }),
          );
          dispatch(
            fetchInvoiceFormDataCreator(
              {
                currentStaffPositionId: userLoginInfo?.staffPositionId,
                division: [],
                pageSize: 10,
                pageNumber: 0,
                formNo: '',
                mrStaffIds: [],
                state: '',
                hq: [],
                startDate: '',
                endDate: '',
              },
              i,
            ),
          );
          dispatch(clearRequestPayloadOrder());
        }
      }
    }
  };

  return (
    <div className="controls-container" ref={controlRef} style={containerStyle}>
      <div
        className={`controls ${componentReady.current ? 'ready' : 'idle'}`}
        style={{width: '100%'}}>
        {segments?.map((item, i) => (
          <div
            key={item.value}
            className={`segment ${i === activeIndex ? 'active' : 'inactive'}`}
            style={itemStyle}
            ref={item.ref}>
            <input
              onClick={() => {
                handleClick(i);
              }}
              data-testid={'toogle-switch-button-' + i}
              type="radio"
              value={item.value}
              id={item.label}
              name={name}
              onChange={() => onInputChange(item.value, i)}
              checked={i === activeIndex}
            />
            <label style={{fontSize: '12.7px'}} htmlFor={item.label}>
              {item.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ZhoToggleSeperator;
